module.exports = __webpack_public_path__ + "img/menu-icon.91a082f0.svg";